"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@chakra-ui/react");
var _Radio = require("../Radio");
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SelectionCard = /*#__PURE__*/(0, _react.forwardRef)(({
  isChecked,
  isDisabled,
  value,
  helperText,
  expandableChildren,
  defaultChecked,
  isRadio,
  label,
  isExpandable,
  size = 'md',
  ...props
}, ref) => {
  const Component = isRadio ? _Radio.Radio : _Checkbox.default;
  const expandableTextSize = size === 'sm' || size === 'md' ? 'xs' : 'sm';
  const hasExpandableContent = isExpandable && isChecked && expandableChildren;
  return /*#__PURE__*/_react.default.createElement(_react2.Box, {
    paddingBottom: hasExpandableContent ? 3 : 0,
    borderRadius: "lg",
    borderColor: isChecked ? 'primary.default' : 'gray.medium',
    borderWidth: "1px",
    _hover: {
      borderColor: isDisabled ? 'gray.medium' : 'primary.default'
    }
  }, /*#__PURE__*/_react.default.createElement(_react2.Box, {
    borderColor: "gray.medium",
    borderBottomWidth: hasExpandableContent ? '1px' : 0
  }, /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    ref: ref,
    isChecked: isChecked,
    isDisabled: isDisabled,
    isFocusable: !isDisabled,
    value: value,
    defaultChecked: defaultChecked,
    helperText: helperText,
    size: size,
    width: "100%",
    paddingX: 4,
    paddingY: 3
  }, props), label)), hasExpandableContent && /*#__PURE__*/_react.default.createElement(_react2.Box, {
    color: "gray.600",
    fontSize: expandableTextSize,
    paddingTop: 3,
    paddingX: 4
  }, expandableChildren));
});
var _default = exports.default = SelectionCard;